<div class="nav-left">
  <ul>
    <li>
      <a (click)="toggleSideMenu()" [title]="'Menu' | translate">
        <mat-icon class="app-menu-icon">
          <i class="fas fa-bars fa-sm"></i>
        </mat-icon>
      </a>
      <hr class="app-menu-h-rule" />
    </li>

    @if (isAdmin) {
      <li>
        <a (click)="navigateTo('/configuration')" [title]="'Sensor Assignments' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-user-cog fa-sm"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Sensor Assignments' | translate }}</span>
        </a>
      </li>
    }

    @if (isAdmin) {
      <li>
        <a (click)="navigateTo('/end-points')" [title]="'End Points' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-desktop fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'End Points' | translate }}</span>
        </a>
      </li>
    }

    @if (isAdmin && canCreateSubusers) {
      <li>
        <a (click)="navigateTo('/user')" [title]="'Users' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-users fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Users' | translate }}</span>
        </a>
      </li>
    }

    @if (isAdmin) {
      <li>
        <a (click)="navigateTo('/sensorlist')" [title]="'Sensors' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-broadcast-tower fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Sensors' | translate }}</span>
        </a>
      </li>
    }

    @if (isAdmin && canViewNotifications) {
      <li>
        <a (click)="navigateTo('/notification-settings')" [title]="'Notification Settings' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-bell fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Notification Settings' | translate }}</span>
        </a>
      </li>
    }

    @if (isSuperAdmin) {
      <li>
        <a [routerLink]="['/tenantSensorList']" routerLinkActive="active" [title]="'Sensors' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-broadcast-tower fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Sensors' | translate }}</span>
        </a>
      </li>
    }

    @if ((isAdmin || isSuperAdmin) && canViewDataAnalysisPage) {
      <li>
        <a (click)="navigateTo('/dataAnalysis')" [title]="'Data Analysis' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-chart-bar fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Data Analysis' | translate }}</span>
        </a>
      </li>
    }

    @if (showAiAnalystAdmin) {
      <li>
        <a (click)="navigateTo('/dashboard/ai-analyst-admin')" [title]="'AI Analyst Admin' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-robot fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'AI Analyst Admin' | translate }}</span>
        </a>
      </li>
    }

    @if (canAccessCorporateReporting) {
      <li>
        <a (click)="navigateTo('/dashboard/corporate-reporting')" [title]="'Corporate Reporting' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-globe fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Corporate Reporting' | translate }}</span>
        </a>
      </li>
    }

    @if (isSuperAdmin) {
      <li>
        <a type [routerLink]="['/userList']" routerLinkActive="active" [title]="'Pre-Signup Users' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-users fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Pre-Signup Users' | translate }}</span>
        </a>
      </li>
    }

    @if (isSuperAdmin) {
      <li>
        <a type [routerLink]="['/tenants']" routerLinkActive="active" [title]="'Tenants' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-building"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Tenants' | translate }}</span>
        </a>
      </li>
    }

    @if (isSuperAdmin) {
      <li>
        <a type [routerLink]="['/deviceVersionList']" routerLinkActive="active" [title]="'Device Versions' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-laptop-code fa-sm side-menu-icon"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Device Versions' | translate }}</span>
        </a>
      </li>
    }

    @if (isSuperAdmin) {
      <li>
        <a type [routerLink]="['/shadowConstraintList']" routerLinkActive="active" [title]="'Shadow Constraints' | translate">
          <mat-icon class="mx-auto">
            <i class="fas fa-pencil-ruler fa-sm"></i>
          </mat-icon>
          <span class="ml-3">{{ 'Shadow Constraints' | translate }}</span>
        </a>
      </li>
    }
  </ul>
</div>
